'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rootNodesInit = exports.rootNodesInit = undefined;

exports.rootNodesInit = rootNodesInit = function rootNodesInit(c) {
    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager,
        apiPath = appManager.getApiPath(),
        displayPropertyUrl = appManager.getDisplayPropertyUrl();

    return {
        baseUrl: apiPath + '/organisationUnits.json',
        params: ['userDataViewFallback=true', 'fields=id,' + displayPropertyUrl + ',children[id,' + displayPropertyUrl + ']', 'paging=false'],
        success: function success(r) {
            appManager.addRootNodes(r.organisationUnits);
            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=rootNodesInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/rootNodesInit.js
 ** module id = 144
 ** module chunks = 0 1
 **/